import Popup from './newsletter/Popup'
import { updateAgreementsPosition } from './newsletter/shared'

import FacebookService from '@/services/FacebookService'
import './Newsletter.scss'

export default class Newsletter {
  /**
   * Newsletter logic
   * 
   * @param {Element} root
   * @param {Element} popupRoot
   */
  constructor (root, popupRoot) {
    this.root = root
    this.popupRoot = popupRoot

    this.wffmForm = null
    this.footerForm = null
    this.popupSigninSection = null
  }

  /* eslint-disable camelcase */  
  getFacebookLoginConfig () {
    /**
     *  Property 'formFields' is solution for situation when login with FB will exist
     *  in more than one place, i.e. in Newsletter we need only 'name' and 'email' but
     *  during creating user account maybe we will need "first_name" and "last_name" as
     *  separate property to fill inputs.
     * 
     *  Used property names in *formFields* are equal to property names that are returned
     *  from FacebookAPI
     */
    return {
      appID: this.getFacebookLoginAppId(),
      loginButtons: this.getFacebookLoginPopupButtons(),
      formFields: {
        first_name: this.getNameFieldFromWFFM(),
        email: this.getEmailFieldFromWffm(),
      },
      methodsToCall: {
        showNewsletterAgreements: this.showNewsletterAgreements.bind(this),
        showNewsletterAgreementsWarning: this.showNewsletterAgreementsWarning.bind(this),
        updateAgreementsPosition: updateAgreementsPosition.bind(null, this.getNewsletterAgreements(), this.popupSigninSection),
        scrollToAgreements: this.scrollToAgreements.bind(this),
        hideFacebookButtonInPopup: this.hideFacebookButtonInPopup.bind(this),
        removeWarningsOnFbSuccess: this.removeWarningsOnFbSuccess.bind(this),
        centerDefaultButtonOnFbSuccess: this.centerDefaultButtonOnFbSuccess.bind(this),
        disableEmailField: this.disableEmailField.bind(this),
      },
    }
  }
  /* eslint-enable camelcase */  

  getFacebookLoginAppId () {
    const popupForm = this.popupRoot.querySelector('.newsletter-signin--form')
    return popupForm.dataset.appid
  }

  getFacebookLoginPopupButtons () {
    return document.querySelectorAll('.fbLogin')
  }

  getWffmForm () {
    return this.popupRoot.querySelector('form')
  }

  getNameFieldFromWFFM () {
    return this.wffmForm.querySelector('.form-control[type="text"]')
  }

  getEmailFieldFromWffm () {
    return this.wffmForm.querySelector('.form-control[type="email"]')
  }

  getNewsletterAgreements () {
    return this.popupSigninSection.querySelector('.agreements')
  }

  showNewsletterAgreements () {
    const agreements = this.getNewsletterAgreements()
    return agreements.classList.add('show')
  }

  showNewsletterAgreementsWarning () {
    const agreementsWarning = this.popupSigninSection.querySelector('.agreements-warning')
    return agreementsWarning.classList.add('show')
  }

  scrollToAgreements () {
    return this.popupRoot.scrollTo(0, document.body.scrollHeight)
  }

  hideFacebookButtonInPopup () {
    const formWrapper = this.popupSigninSection.querySelector('.newsletter-signin--form')
    return formWrapper.classList.add('facebook-hidden')
  }

  removeWarningsOnFbSuccess () {
    /**
     *  @description: if user got validation error message in "Name/Email" field,
     *  and then he used FB data, we need to hide WFFM validaion messages because
     *  WFFM will not refresh them automatically.
     */
    const nameInput = this.getNameFieldFromWFFM()
    const emailInput = this.getEmailFieldFromWffm()

    function removeNameErrorMessage () {
      nameInput.parentElement.classList.remove('has-error')
      nameInput.parentElement.classList.add('fieldValid')
      nameInput.nextElementSibling.innerHTML = ''
    }

    function removeEmailErrorMessage () {
      emailInput.parentElement.classList.remove('has-error')
      emailInput.parentElement.classList.add('fieldValid')
      emailInput.nextElementSibling.innerHTML = ''
    }

    removeNameErrorMessage()
    removeEmailErrorMessage()
  }

  centerDefaultButtonOnFbSuccess () {
    const form = this.popupSigninSection.querySelector('.newsletter-signin--form')
    return form.classList.add('center-btn')
  }

  /**
   * This field needs to be disabled here because client established that
   * when we use facebook data its the most correct data we want
   * after use login with FB.
   */
  disableEmailField () {
    const emailInput = this.getEmailFieldFromWffm()
    return emailInput.parentElement.classList.add('input-disabled')
  }

  getUserEmailFromFooterFormInput () {
    return this.footerForm.querySelector('input').value    
  }

  /**
   * Setup popup form with data that depends on clicked button
   */
  setupPopupForm () {
    const popup = new Popup(this.popupRoot, this.getUserEmailFromFooterFormInput())
    popup.showComponent()
  }

  initFacebookService () {
    const facebookLoginConfig = this.getFacebookLoginConfig()
    const facebookService = new FacebookService(facebookLoginConfig)
  
    return facebookService.init()
  }

  initPopup () {
    /**
     * Setting up popup globals
     */
    const component = new Popup(this.popupRoot)
    this.popupSigninSection = this.popupRoot.querySelector('#newsletter-signin')
    this.wffmForm = this.getWffmForm()
    
    return component.init()
  }

  initNewsletter () {
    if (!this.popupRoot || !this.getWffmForm()) {
      log.warn('Warning! NewsletterPopup component or its WFFM form is not configured at this page.')
      return
    }

    // If newsletter html in footer does not exist we still should be able to run popup i.e. from "utm" QS param
    this.initPopup()
    this.initFacebookService()

    // Prevent page from loading newsletter JS if newsletter root does not exist
    if (!this.root) return

    this.footerForm = this.root.querySelector('.footer-newsletter__form')

    const buttons = this.footerForm.querySelectorAll('button')
    buttons.forEach(button => {
      button.addEventListener('click', () => this.setupPopupForm())      
    })
  }
}


// WEBPACK FOOTER //
// ./src/components/Newsletter.js